export default __webpack_public_path__ + "static/let-godoy-11fd22a0d51d0c8c636bed6dad2b8df8.jpg";